import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../auth/useAuth";
import { applyReturnToNavigation } from "../utils/sanitizeReturnTo";
import { getDefaultPostLoginDestination } from "../auth/partnerAccess";
import { DEFAULT_POST_LOGIN_HASH } from "../auth/adminAccess";

const AuthCallbackPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refreshUser } = useAuth();

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const user = await refreshUser();

      if (cancelled) {
        return;
      }

      if (!user) {
        navigate("/login?error=google_auth_failed", { replace: true });
        return;
      }

      const returnTo =
        searchParams.get("returnTo") ||
        getDefaultPostLoginDestination(user) ||
        DEFAULT_POST_LOGIN_HASH;

      if (user.consent?.requiresConsent) {
        navigate("/account/consent-required", {
          replace: true,
          state: { returnTo },
        });
        return;
      }

      applyReturnToNavigation(returnTo, navigate);
    })();

    return () => {
      cancelled = true;
    };
  }, [navigate, refreshUser, searchParams]);

  return (
    <div className="midpoint-app auth-page">
      <div className="auth-login-card panel-card">
        <p className="eyebrow">Midpoint</p>
        <h1>Signing you in</h1>
        <p className="muted">Completing sign-in…</p>
      </div>
    </div>
  );
};

export default AuthCallbackPage;
